module.exports = __webpack_public_path__ + "img/dark_baggage.4974bf88.png";